import {defineStore} from 'pinia'
import {getApproveNum} from '@/api/home/home'
import {documentPoint, sendVideoCut} from '@/api/device/device'
import {useGlobal} from '@/store/global'
import {useMethodStore} from '@/store/method'
import {Toast, Dialog} from 'vant'
import eventBus from '@/utils/eventBus'
import router from '@/router/index'
import {logPost} from '@/utils/xlog'
import {Device} from '@hybird/device'
import { ref } from 'vue'

export const useStore = defineStore('main', {})

export const useMapOneself = defineStore('oneself', {
  state: () => {
    return {
      location: {
        site: '',
        center: []
      }
    }
  }
})

export const useFormData = defineStore('formDatas', {
  state: () => {
    return {
      formData: {
        isGet: false,
        stampList: [],
        state: {
          sealPeople: {}
        }
      }
    }
  }
})

export const useHomeStore = defineStore('home', {
  state: () => {
    return {
      badge: 0
    }
  },
  actions: {
    async getBadge() {
      console.log('角标')
      // const res = await getApproveNum()
      // if (res.code === 0) {
      //   this.badge = res.data
      // }
    }
  }
})

// 设备列表
export const useDeviceStore = defineStore('deviceList', {
  state: () => {
    return {
      secretSealProcess:false,
      deviceList: ref([]), // 设备列表
      jurisdictionList: [], // 权限列表
      device: {}, // 盖印已选择的设备
      isConnect: false, //设备是否已连接
      isUpgrade: false, // 是否在升级中
      isSelfUserLogout: false, //是否自己控制退出登录
      isRemoteLock: false, // 是否设备锁定
      connectDeviceNumber: '111111', //已连接设备编号
      isDeviceUpgraded: false, // 是否是最新
      deviceDetail: {}, // 当前选择设备
      heartBitStartTimer: null,
      heartBitEndTimer: null,
      isHeartBitEndTimerInit: false,
      isResumed: true,
      sealSuccess: false, // 当前印章是否用印完成
      sealStamp: false, // 当前印章是否在补拍页面点击了按钮盖印 认证模式
      jumpRemake: false, //是否前往补拍页面
      SystemsCamera: false,
      notDisConnect: false, //是否保持连接不断开（待用印列表，待用印详情）
      connectDocumentId: 0, //当前用印的文件
      connectSealId: 0, //当情用印的印章
      connectModel: '', //当前连接的印章类型
      connectDeviceVersion: '', //当前连接设备的固件
      models: {
        _YDA_A: '2.3.1',
        _YDA_APlus: '2.4.0',
        _YDA_J: '1.1.0',
        _YDA_AS: '1.0.0'
      }, //连接不断开逻辑固件版本号划分（大于该固件版本支持）
      //当前的处于连接盖印的设备，此次连接过程中是否验证过指纹 (断开连接重置状态) | 没开启指纹验证为true
      isFingerprint: false,
      isCancel: false,
      isFirstChoose: true, // 是否首次进入选择
      keepAliveErr: {
        1037: '设备已被占用',
        100001: '设备连接失败请尝试重新连接',
        100002: '设备未激活请联系客服',
        100003: '连接中断请重新连接使用'
      },
      setTimeOutKeepAliveTimer: null,
      noSendOpen: false, // 不需要在次发送开仓
      fromRemake: false,
      protocolBeginSeal: null,
      isLeavingFromSeal: false
    }
  },
  actions: {
    async deviceLogout(disconnect = true) {
      eventBus.emit('deviceLogout')
      console.log('store deviceLogout', this.connectDeviceNumber)
      this.restConnectInfo()
      this.isConnect = false
      this.device = {}

      if (disconnect) {
        const deviceProtocol = Device.getByNumber(
                this.connectDeviceNumber
        )?.deviceProtocol
        await deviceProtocol?.disconnect()
      }
    },
    documentOverTime() {
    },
    setNotDisConnect(val) {
      this.notDisConnect = val
    },
    setConnectDocumentId(val = 0) {
      this.connectDocumentId = val
    },
    setConnectSealId(val = 0) {
      this.connectSealId = val
    },
    cancelSealMode() {
      console.log('cancelSealMode盖印退登', this.isNewSeal())
      const isNew = this.isNewSeal()
      if (isNew) {
        let deviceProtocol = Device.getByNumber(
                this.connectDeviceNumber
        )?.deviceProtocol
        deviceProtocol?.endSeal()
      } else {
        this.deviceLogout()
      }
    },
    restConnectInfo() {
      this.connectDocumentId = 0
      this.connectModel = ''
      this.connectSealId = 0
      this.connectDeviceVersion = ''
      this.isFingerprint = false
    },
    setConnectModel(val = '') {
      this.connectModel = val
    },
    setConnectDeviceVersion(val = '') {
      this.connectDeviceVersion = val
    },
    setIsFingerprint(val = false) {
      this.isFingerprint = val
    },
    //是否是新版本固件
    getIsNew() {
      let version = ''
      if (this.connectModel == 'YDA-A') {
        version = this.models['_YDA_A']
      }
      if (this.connectModel == 'YDA-APlus') {
        version = this.models['_YDA_APlus']
      }

      if (this.connectModel == 'YDA-J') {
        version = this.models['_YDA_J']
      }
      if (this.connectModel == 'YDA-AS') {
        version = this.models['_YDA_AS']
      }

      if (version == '') return false

      return this.connectDeviceVersion > version
    },
    //是否需要最新连接不断开逻辑
    isNewSeal() {
      //a款暂时不做，不需要区分固件版本
      const isNew = this.getIsNew()
      return isNew && this.connectModel != 'YDA-A'
    },
    setIsCancel(val = false) {
      this.setIsCancel = val
    },
    //用印埋点
    documentPoint(documentId, type) {
      const params = {
        documentId,
        type
      }
      documentPoint(params)
    },
    //清除设备信息
    clearDevice() {
      this.restConnectInfo()
      this.isConnect = false
      this.device = {}
    },
    setProtocolBeginSeal(protocol) {
      this.protocolBeginSeal = protocol
    },
    clearProtocolBeginSeal() {
      this.protocolBeginSeal = null
    },

    setIsLeavingFromSeal(bol) {
      this.isLeavingFromSeal = bol
    },


  }
})

export const useUserStore = defineStore('userInfo', {
  state: () => {
    return {
      userInfo: {},
      isDisabled: false
    }
  },
  actions: {
    setIsDisabled(val) {
      this.isDisabled = !!val
    }
  }
})

export const useRecord = defineStore('useRecord', {
  state: () => {
    return {
      sizerTypeList: '',
      cameraSteam: null
    }
  }
})
//临时盖印人
export const temporaryStore = defineStore('temporary', {
  state: () => {
    return {
      temporarySealerId: null,
      sealIds: [],
      remark: ''
    }
  },
  actions: {
    setreserve() {
      this.temporarySealerId = null
      this.sealIds = []
      this.remark = ''
    }
  }
})
// 地理位置获取
export const useMapStore = defineStore('useMap', {
  state: () => {
    return {
      center: {} // 坐标及信息
    }
  },

  actions: {
    // 多次获取坐标并存储
    // getCoordinate() {
    //   var that = this
    //   let num = 0
    //   let timer = setInterval(async () => {
    //     if (num == 5) {
    //       return clearInterval(timer)
    //     }
    //     num ++
    //     that.center = await getGDLocation()
    //     console.log('数据回来了', that.center);
    //   }, 0);
    // }
  }
})
export const useSealVideoStore = defineStore('sealVideo', {
  state: () => {
    return {
      beginSealTime: new Date().valueOf() //开始盖印时间
    }
  },
  actions: {
    getBeginTime() {
      if (this.beginSealTime != 0) {
        this.beginSealTime = 0
      }
      let data = new Date().valueOf()
      this.beginSealTime = data
      console.log('beginTIme-xxxx', this.beginSealTime)
    },
    async sendTime(data) {
      let now = new Date().valueOf()
      let time = now - this.beginSealTime
      console.log('beginTIme-sendTime', time)
      await sendVideoCut({
        videoType: 2,
        cutStart: Number((time / 1000).toFixed(0)),
        cutEnd: Number((time / 1000).toFixed(0)),
        ...data
      })
    }
  }
})

export const HEAD_EVENT_TYPE = {
  SET_HEAD_COLOR: 'SET_HEAD_COLOR',
  SET_HEAD_HIDE: 'SET_HEAD_HIDE',
  SET_HEAD_TITLE: 'SET_HEAD_TITLE'
}

export const useHeadStore = defineStore('head', {
  state: () => {
    return {
      zIndex: 9999,
      eventListenerList: {}
    }
  },
  actions: {
    setZIndex(val = 0) {
      this.zIndex = val
    },
    [HEAD_EVENT_TYPE.SET_HEAD_COLOR](data) {
      this.eventListenerList[HEAD_EVENT_TYPE.SET_HEAD_COLOR] &&
      this.eventListenerList[HEAD_EVENT_TYPE.SET_HEAD_COLOR](data)
    },
    notifyEventCallback(eventType, data) {
      this.eventListenerList[eventType] &&
        this.eventListenerList[eventType](data)
    },
    addEventListener(EVENT_KEY, callback) {
      this.eventListenerList[EVENT_KEY] = callback
    }
  }
})

export const useEnvStore = defineStore('env', {
  state: () => {
    return {
      deviceInfo: null,
      envConfig: null
    }
  },
  actions: {
    setDeviceInfo(data) {
      this.deviceInfo = data
    },
    setEnvConfig(data) {
      this.envConfig = data
    }
  }
})
